import { TFunction } from 'i18next'

import {
  HomepageWidgetType,
  HomepageWidgetTypeEnum,
  ShortcutType,
  ShortcutTypeEnum,
} from './home-screen.types'

export const ALL_WIDGET_TYPES: HomepageWidgetType[] = [...HomepageWidgetTypeEnum.options]

export const ALL_SHORTCUT_TYPES: ShortcutType[] = [...ShortcutTypeEnum.options]

export const MAX_ENABLED_SHORTCUTS = 4

export const BLOCKS_GRID_COLUMNS = 'repeat(auto-fit, minmax(32rem, 1fr))'

export const getWidgetLabels = (
  t: TFunction<['home-screen']>,
): Record<HomepageWidgetType, string> => ({
  amenities: t('home-screen:widgetLabels.amenities'),
  announcements: t('home-screen:widgetLabels.announcements'),
  buildingEssentials: t('home-screen:widgetLabels.buildingEssentials'),
  buildingImage: t('home-screen:widgetLabels.buildingImage'),
  chat: t('home-screen:widgetLabels.chat'),
  neighborhoodPerks: t('home-screen:widgetLabels.neighborhoodPerks'),
  residentTasks: t('home-screen:widgetLabels.residentTasks'),
  services: t('home-screen:widgetLabels.services'),
  shortcuts: t('home-screen:widgetLabels.shortcuts'),
  transport: t('home-screen:widgetLabels.transport'),
  upcomingEvents: t('home-screen:widgetLabels.upcomingEvents'),
})

export const getShortcutLabels = (t: TFunction<['home-screen']>): Record<ShortcutType, string> => ({
  bookings: t('home-screen:shortcutLabels.bookings'),
  callUs: t('home-screen:shortcutLabels.callUs'),
  emailUs: t('home-screen:shortcutLabels.emailUs'),
  essentials: t('home-screen:shortcutLabels.essentials'),
  maintenanceRequests: t('home-screen:shortcutLabels.maintenanceRequests'),
  packages: t('home-screen:shortcutLabels.packages'),
  parking: t('home-screen:shortcutLabels.parking'),
  payRent: t('home-screen:shortcutLabels.payRent'),
  unlockDoor: t('home-screen:shortcutLabels.unlockDoor'),
  visitors: t('home-screen:shortcutLabels.visitors'),
})
